import React from "react";
import styles from "../../assets/styles/Marketers/Marketers.module.scss";
import { AppPage, MimaText, PageLoader } from "../../components";

const ForeignBankAccounts = ({ foreignBankAccounts, loading }) => {
  return (
    <AppPage pageTitle="Foreign Bank Accounts">
      {loading ? (
        <PageLoader title="While we set things up for you" />
      ) : (
        <>
          <div className={styles.insights}>
            {foreignBankAccounts?.map((item, i) => (
              <div key={i}>
                <MimaText variant="bodyBold" mb={1}>
                  {`${item.metadata.country} ACCOUNT INFORMATION`}
                </MimaText>
                <div className={styles.insights__group}>
                  {item?.metadata?.data?.map((x, index) => (
                    <div key={index} className={styles.insights__group__item}>
                      <MimaText labelTitle={x.label} variant="small" mb={0.5}>
                        {x.value}
                      </MimaText>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </AppPage>
  );
};

export default ForeignBankAccounts;
